import type { ClientInfraNotes } from './index';

export const KCIA_CLIENT_ID = '6779541715';

/**
 * @CLAUDE
 * Input type: HLS?
 * Wowza instance name: 6779541715_KCIA-camera2_247
 * prot:IP:port: wowz://34.222.84.145:42704 
 * 
 * m3u8
 * https://api.v3.invintus.com/StreamURI/persis/6779541715/KCIA-camera2/media.m3u8
 * [FORMAT]
 *  filename=https://api.v3.invintus.com/StreamURI/persis/6779541715/KCIA-camera2/media.m3u8
 *  nb_streams=3
 *  nb_programs=1
 *  nb_stream_groups=0
 *  format_name=hls
 *  format_long_name=Apple HTTP Live Streaming
 *  start_time=7576.322000
 *  duration=N/A
 *  size=N/A
 *  bit_rate=N/A
 *  probe_score=100
 * [/FORMAT]
 */

export const kciaNotes: ClientInfraNotes = {
  clientName: 'King County International Airport (KCIA)',
  protocol: {
    actual: 'TS over SRT',
    note: '',
  },
  portPattern: '42710 (cam1), 42704 (cam2) — cam4/cam5 use Stream Target relay (no direct port)',
  configLocation: {
    system: 'Wowza Streaming Engine Manager',
    path: '"persis" application → Stream Files',
    credentials: '1Password → search "Persistent Stream monitoring - Wowza"',
    url: 'http://persis.invintus.live:8088/enginemanager/login.htm',
  },
  notes: [
    {
      title: 'Shared Wowza server',
      description: 'KCIA streams are technically 24/7 streams so not on the *.w1.invintus.com or whatever the database URIs suggest.',
    },
    {
      title: 'Persistent stream cameras',
      description:
        'Cam1 (KCIA-camera1, tifkljs1): Runway. ' +
        'Cam2 (KCIA-camera2, pnnuw9bw): Tower. ' +
        'Cam4 (KCIA-camera4, dqvm1jpp): DB Schenker East. ' +
        'Cam5 (KCIA-camera5, eas9oziy): DB Schenker West. ' +
        'All relay through ingress.w1 Stream Targets to persis.invintus.live.',
    },
  ],
};
